import {styled} from "@mui/material/styles"
import {Grid} from "@mui/material"
import {breakpoints} from "@next/themes"
import {STICKY_HEADER_SCROLL_TRIGGER} from "../../../../config/constants"

export const ResultsGrid = styled(Grid)`
    padding: 0;
    margin-top: 4.75rem;

    @media (min-width: ${breakpoints.values.md}px) {
        padding: 4.75rem 1rem 0 1rem;
        margin-top: 0;
    }

    @media (min-width: ${breakpoints.values.lg}px) {
        padding: 0.75rem 1rem 0 1rem;
    }

    @media (min-width: ${breakpoints.values.xl}px) {
        padding: 0.75rem 1.5rem 0 1.5rem;
        position: relative;
    }
`

export const RelativeContainer = styled("div")`
    min-height: ${STICKY_HEADER_SCROLL_TRIGGER}px;
    width: 100%;
    position: relative;
    z-index: 4;
    height: 3.5rem;
    @media (min-width: ${breakpoints.values.lg}px) {
        display: none;
    }
`
